module.exports = __webpack_public_path__ + "static/media/1001001BE.cfb24375.jpg";